<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn icon small @click="close" color="primary">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3 class="ml-2">{{ process.name }} Log</h3>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-0"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                fixed-header
            >
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ProcessesDataLog',
    props: {
        process: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        loading: false,
        headers: [
            {
                text: 'MONTH',
                value: 'month',
                align: 'center',
                sortable: false,
            },
            {
                text: 'MINIMUM CAPACITY',
                value: 'minimumCapacity',
                align: 'left',
                sortable: false,
            },
            {
                text: 'WORK DAYS',
                value: 'workDays',
                align: 'left',
                sortable: false,
            },
            {
                text: 'MINIMUM CAPACITY PER DAY',
                value: 'minimumCapacityPerDay',
                align: 'left',
                sortable: false,
            },
            {
                text: 'LABOR VALUE',
                value: 'laborValue',
                align: 'left',
                sortable: false,
            },
        ],
        items: [],
    }),
    async mounted() {
        try {
            this.loading = true
            // get current month
            this.currentMonth = moment(new Date()).format('YYYY-MM')

            const months = Object.keys(
                this.process.minimumCapacityInMonth || {}
            )
            // divide items in months.
            this.items = months.map(month => ({
                month,
                minimumCapacity: this.process.minimumCapacityInMonth[month],
                laborValue: this.process.laborValue?.[month] || 0,
                workDays: this.process.workDays?.[month] || 0,
                minimumCapacityPerDay:
                    (+this.process.minimumCapacityInMonth[month] || 0) /
                    (+this.process.workDays?.[month] || 0),
            }))
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        formatDate(date) {
            return moment
                .unix(date.seconds || date._seconds)
                .format('YYYY-MM-DD')
        },
        close() {
            this.$emit('closeDialog')
        },
    },
}
</script>

<style>
.v-data-table__wrapper {
    max-height: 50vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 64px;
}
thead {
    position: sticky;
    z-index: 1;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
</style>
